import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-planogramm',
  templateUrl: './planogramm.component.html',
  styleUrls: ['./planogramm.component.scss']
})
export class PlanogrammComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
